import React, { useEffect, useState } from "react";
import Nav from "../master/NavBar";
import Header from "../master/SideBar";
import {
  branchStudentDelete,
  branchStudentUpdate,
  transferList,
} from "../../api/BranchService";
import Pagination from "../components/Pagination";
import Swal from "sweetalert2";
import { closeModal, LoadingDiv, SweetAlertShow } from "../master/Master";
import { batchList } from "../../api/Batch";
import Master from "./Master";
import TransferBranchLayout from "./TransferBranchLayout";

export default function StudentTransferList() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const [filters, setFilters] = useState({
    status: "2",
  });

  const [selectedStudent, setSelectedStudent] = useState({});
  const [batches, setBatches] = useState([]);
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    const parseSessions = JSON.parse(localStorage.getItem("sessions") ?? "[]");
    setSessions(parseSessions);

    // default active session set
    const activeSession = parseSessions.find((s) => s.status === "1");
    if (activeSession) {
      setSelectedStudent((prev) => ({
        ...prev,
        session_id: activeSession.id,
      }));
    }
  }, []);

  useEffect(() => {
    getBatchList();
  }, []);

  const getBatchList = async () => {
    const res = await batchList();
    setBatches(res.data.data);
  };

  useEffect(() => {
    fetchList();
  }, [filters]);

  const handleUpdate = async () => {
    try {
      const payload = {
        id: selectedStudent.id,
        batch_id: selectedStudent.batch_id,
        session_id: selectedStudent.session_id,
      };

      const response = await branchStudentUpdate(payload);
      setLoading(true);

      if (response.data.status) {
        closeModal("exampleModal");
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      fetchList();
    }
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to recover this student!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });
    if (!confirm.isConfirmed) return;

    setLoading(true);
    try {
      const response = await branchStudentDelete(id);
      if (response.data.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      fetchList();
    }
  };

  const fetchList = async () => {
    try {
      setLoading(true);

      let addUrl = "";
      Object.keys(filters).forEach((key) => {
        if (filters[key]) {
          addUrl += `&${key}=${filters[key]}`;
        }
      });

      const res = await transferList(addUrl);
      setData(res?.data?.data || []);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid mt-2">
                <div className="row">
                  <TransferBranchLayout />

                  <div className="col-md-12">
                    <div className="card p-3">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="text-primary mb-0">
                          Student Transfer List
                        </h4>
                      </div>
                      <div className="btn-group col-7" role="group">
                        <button
                          type="button"
                          className={`btn ${
                            filters.status === "5"
                              ? "btn-warning"
                              : "btn-outline-warning"
                          }`}
                          onClick={() =>
                            setFilters({ ...filters, status: "5" })
                          }
                        >
                          Panding
                        </button>

                        <button
                          type="button"
                          className={`btn ${
                            filters.status === "2"
                              ? "btn-primary"
                              : "btn-outline-primary"
                          }`}
                          onClick={() =>
                            setFilters({ ...filters, status: "2" })
                          }
                        >
                          New Request
                        </button>

                        <button
                          type="button"
                          className={`btn ${
                            filters.status === "1"
                              ? "btn-success"
                              : "btn-outline-success"
                          }`}
                          onClick={() =>
                            setFilters({ ...filters, status: "1" })
                          }
                        >
                          Accepted
                        </button>
                        <button
                          className={`btn ${
                            filters.status === "4"
                              ? "btn-info"
                              : "btn-outline-info"
                          }`}
                          onClick={() =>
                            setFilters({ ...filters, status: "4" })
                          }
                        >
                          Transferred
                        </button>
                      </div>

                      {/* 🔥 Table */}
                      <div className="table-responsive">
                        <table className="table table-hover align-middle">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Branch</th>
                              <th>Reg No.</th>
                              <th>Name</th>
                              <th>Mobile</th>
                              <th>Branch Name</th>
                              <th>Transfer Date</th>
                              <th>Action</th>
                            </tr>
                          </thead>

                          <tbody>
                            {data?.data?.map((item, index) => {
                              const s = item?.student_data
                                ? JSON.parse(item.student_data)
                                : {};

                              return (
                                <tr key={item.id}>
                                  <td>{index + 1}</td>
                                  <td>{item.branch.name || "-"}</td>

                                  <td>{s.registration_no || "-"}</td>

                                  <td>{s.name || "-"}</td>

                                  <td>{s.phone || "-"}</td>
                                  <td>{s.village || "-"}</td>

                                  <td>
                                    {item.transfer_date
                                      ? new Date(
                                          item.transfer_date,
                                        ).toLocaleDateString("en-GB", {
                                          day: "2-digit",
                                          month: "short",
                                          year: "numeric",
                                        })
                                      : "-"}
                                  </td>

                                  <td>
                                    <div className="d-flex gap-3">
                                      {filters.status === "2" && (
                                        <i
                                          className="bi bi-pencil-square text-primary"
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "18px",
                                          }}
                                          data-bs-toggle="modal"
                                          data-bs-target="#exampleModal"
                                          onClick={() =>
                                            setSelectedStudent(item)
                                          } // ✅ important
                                        ></i>
                                      )}

                                      {(filters.status === "2" ||
                                        filters.status === "5") && (
                                        <i
                                          className="bi bi-trash text-danger"
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "18px",
                                          }}
                                          onClick={() => handleDelete(item.id)}
                                        ></i>
                                      )}

                                      {filters.status === "1" && (
                                        <i
                                          className="bi bi-check-circle text-success"
                                          style={{ fontSize: "18px" }}
                                          title="Accepted"
                                        ></i>
                                      )}

                                      {filters.status === "4" && (
                                        <i
                                          className="bi bi-arrow-right-circle text-info"
                                          style={{ fontSize: "18px" }}
                                          title="Transferred"
                                        ></i>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>

                        <Pagination
                          data={data}
                          setFilters={setFilters}
                          filters={filters}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Accepted Student In Batch</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              <select
                className="form-control mb-2"
                value={selectedStudent?.session_id || ""}
                onChange={(e) =>
                  setSelectedStudent({
                    ...selectedStudent,
                    session_id: e.target.value,
                    batch_id: "",
                  })
                }
              >
                <option value="">Select Session</option>
                {sessions.map((item, index) => (
                  <option key={index} value={item.id}>
                    {item.session}
                  </option>
                ))}
              </select>

              <select
                className="form-control"
                value={selectedStudent?.batch_id || ""}
                onChange={(e) =>
                  setSelectedStudent({
                    ...selectedStudent,
                    batch_id: e.target.value,
                  })
                }
              >
                <option value="">Select Batch</option>
                {batches
                  .filter(
                    (batch) => batch.session_id == selectedStudent?.session_id,
                  )
                  .map((batch) => (
                    <option key={batch.id} value={batch.id}>
                      {batch.title} ({batch.course.title})
                    </option>
                  ))}
              </select>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>

              <button
                type="button"
                className="btn btn-primary"
                onClick={handleUpdate}
                disabled={
                  !selectedStudent?.batch_id || !selectedStudent?.session_id
                }
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
